/**
 * AdminRoute — 관리자 전용 라우트 보호 컴포넌트
 *
 * · isAdmin=false 인 사용자가 URL 직접 접근 시 → 대시보드로 리다이렉트
 * · 미로그인 상태 → /auth 로 리다이렉트
 */
import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

interface AdminRouteProps {
  children: React.ReactNode
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { isLoggedIn, isAdmin } = useAuthStore()

  if (!isLoggedIn) {
    return <Navigate to="/auth" replace />
  }

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center h-full min-h-[60vh] gap-4 p-8">
        <div className="text-5xl">🔒</div>
        <h2 className="text-xl font-bold text-slate-700">관리자 전용 페이지</h2>
        <p className="text-sm text-slate-500 text-center">
          이 페이지는 관리자 계정으로만 접근할 수 있습니다.<br />
          학습 페이지로 돌아가세요.
        </p>
        <a
          href="/"
          className="mt-2 bg-primary-600 text-white px-6 py-2.5 rounded-xl text-sm font-bold hover:bg-primary-700 transition-colors"
        >
          대시보드로 이동
        </a>
      </div>
    )
  }

  return <>{children}</>
}
